import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import {
  ageAssessmentBasePath,
  dentalBasePath,
  errorRequestHandel,
} from "../../../helper";
import { getDashboardData } from "../../../components/https/projects-apis";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { _setProjectTab } from "../../../redux/actions/generalAction";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";
import ProjectStatusCard from "../../../dentail-indetifcation/components/d-dashboard/ProjectStatusCard";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";
import ProjectGraphAndTable from "../../../dentail-indetifcation/components/d-dashboard/ProjectGraphAndTable";
import RecentProjects from "../../../dentail-indetifcation/components/d-dashboard/RecentProjects";
import AgeAssessmentShortCut from "./child/AgeAssessmentShortCut";
import RecentCases from "./child/RecentCases";
import CaseGraphAndProgressBar from "./child/CaseGraphAndProgressBar";
import { getAgeAssessmentDashoboardData } from "../../../components/https/age-assessment-apis";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);

  const navigation = (type) => {
    // all,open,completed,archive
    navigate(`${ageAssessmentBasePath}/cases`);
  };

  useEffect(() => {
    getDashboadData();
  }, []);

  const getDashboadData = async () => {
    try {
      setLoading(true);
      const response = await getAgeAssessmentDashoboardData();
      if (response.status === 200) {
        setData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  return (
    <div>
      <AgeAssessmentShortCut />

      <Row gutter={[20, 20]}>
        <Col md={8} sm={24} xs={24}>
          <CustomCard>
            <ProjectStatusCard
              title={"Total Cases"}
              bgColor={"#E3EBFF"}
              icon={dentalIcons?.totalProjectsIcon}
              count={data?.total_projects}
              onClick={() => navigation("all")}
            />
          </CustomCard>
        </Col>

        <Col md={8} sm={24} xs={24}>
          <CustomCard>
            <ProjectStatusCard
              title={"Completed Cases"}
              bgColor={"#D2F3FA"}
              icon={dentalIcons?.completedProjectIcon}
              count={data?.completed_projects}
              onClick={() => navigation("completed")}
            />
          </CustomCard>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <CustomCard>
            <ProjectStatusCard
              title={"New Cases"}
              bgColor={"#DEF5DB"}
              icon={dentalIcons?.activeProjectsIcon}
              count={data?.new_projects}
              onClick={() => navigation("open")}
            />
          </CustomCard>
        </Col>
      </Row>
      <br />
      <br />
      <CaseGraphAndProgressBar data={data} />
      <br />
      <br />
      <RecentCases data={data?.recent_projects || []} />
    </div>
  );
};

export default Dashboard;
